
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"45.2","height":"44.8","viewBox":"0 0 45.2 44.8"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#EFEFEA","d":"M43 40.2c-4.2 5-10.3 3.6-10.3 3.6-8.8-1.2-16.7-8.1-16.7-8.1C1.3 23.1 1.2 14.6 1.2 14.6-.7 6.6 5.1 1.8 5.1 1.8c2.3-2 4.7-.4 4.7-.4l6.6 6.5c2.9 3-.1 5.7-.1 5.7l-3 3c4.3 9.7 15.1 15.3 15.1 15.3l3.9-3.9c2.5-1.6 4.2.2 4.2.2l6.6 6.5c2.8 3.4-.1 5.5-.1 5.5z"}})])
          )
        }
      }
    